"use strict";

($dt => {

	/**
	 * Success screen
	 * 
	 * @param {Block} block 
	 * @param {InnerScreen} inner_screen 
	 * @param {*} controller 
	 */
	$dt.TopicGrid.ScreenFunctions.o0_i7 = (block, inner_screen, controller, toggle_left_pane) => {
		// Success screen
		const { inner_elem } = inner_screen;
		const [ button_next_elem ] = [
			inner_elem.querySelector('.button-next')
		];

		button_next_elem.addEventListener('click', () => {
			controller.CloseTopicDetails(block);
		});

		// Load Order Details
		inner_screen.Show = () => {
			const [ conf_number_elem, summary_elem ] = [
				inner_elem.querySelector('.confirmation-number'),
				inner_elem.querySelector('.schedule-summary')
			];

			toggle_left_pane(false);
			conf_number_elem.innerHTML = block.scheduling_info.order_id;
			summary_elem.innerHTML = controller.CreateHtmlSummary(block, true, false, true);
		};
	};

})(window.d3_wp_themejs);
